import JobZImage from "../../../../common/jobz-img";
import { publicUrlFor } from "../../../../../globals/constants";

function SectionOfficePhotos1() {
    return (
        <>
            <h4 className="twm-s-title">Office Photos</h4>
            <div className="tw-sidebar-gallery">
                <ul>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic1.jpg")} title="Title 1" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic1.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic1.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic2.jpg")} title="Title 2" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic2.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic2.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb ">
                            <a className="elem" href={publicUrlFor("images/gallery/pic3.jpg")} title="Title 3" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic3.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic3.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic4.jpg")} title="Title 4" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic4.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic4.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic5.jpg")} title="Title 5" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic5.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic5.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic6.jpg")} title="Title 6" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic6.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic6.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic7.jpg")} title="Title 7" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic1.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic7.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic8.jpg")} title="Title 8" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic2.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic8.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb ">
                            <a className="elem" href={publicUrlFor("images/gallery/pic9.jpg")} title="Title 9" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic3.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic9.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic10.jpg")} title="Title 10" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic4.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic10.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic11.jpg")} title="Title 11" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic5.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic11.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="tw-service-gallery-thumb">
                            <a className="elem" href={publicUrlFor("images/gallery/pic12.jpg")} title="Title 12" data-lcl-author data-lcl-thumb={publicUrlFor("images/gallery/thumb/pic6.jpg")}>
                                <JobZImage src="images/gallery/thumb/pic12.jpg" alt="" />
                                <i className="fa fa-file-image" />
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default SectionOfficePhotos1;